var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.77,
    height: 19.768,
    viewBox: "0 0 19.77 19.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-send",
    "data-name": "Icon ionic-ios-send",
    d: "M23.149,4.047l-18.9,8.238a.433.433,0,0,0,.015.788l5.113,2.889a.824.824,0,0,0,.942-.093L20.4,7.177c.067-.057.227-.165.288-.1s-.036.221-.093.288l-8.722,9.824a.822.822,0,0,0-.082.983l3.342,5.36a.435.435,0,0,0,.783-.01l7.816-18.9A.433.433,0,0,0,23.149,4.047Z",
    transform: "translate(-4.002 -4.003)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3955e9de922ba83f03f8db6efba0d214.svg";
export { ForwardRef as ReactComponent };